import { useState } from 'react'
import type { Apu } from './tipos'
import { CATEGORIAS_APU } from './tipos'
import { IconoCerrar } from '@/shared/ui/Iconos/Iconos'
import estilos from './BancoApus.module.css'

type Props = {
  abierto: boolean
  siguienteCodigo?: string
  proyectosDisponibles?: Array<{ id: string; nombre: string }>
  onCerrar: () => void
  onCrear: (nuevo: Partial<Apu>) => void
}

export function ModalCrearApu({ abierto, siguienteCodigo = '', proyectosDisponibles = [], onCerrar, onCrear }: Props) {
  const [codigo, setCodigo] = useState(siguienteCodigo)
  const [nombre, setNombre] = useState('')
  const [descripcion, setDescripcion] = useState('')
  const [unidad, setUnidad] = useState('UND')
  const [categoria, setCategoria] = useState<string>('General')
  const [proyectoId, setProyectoId] = useState<string>('')

  // Sincronizar si cambia el siguiente código
  useState(() => {
    if (siguienteCodigo && !codigo) {
      setCodigo(siguienteCodigo)
    }
  })

  if (!abierto) return null

  function handleSubmit(e: React.FormEvent) {
    e.preventDefault()
    if (!nombre.trim()) return

    const proyElegido = proyectosDisponibles.find((p) => p.id === proyectoId)

    onCrear({
      codigo: codigo.trim() || siguienteCodigo || 'APU-001',
      nombre: nombre.trim(),
      descripcion: descripcion.trim(),
      unidad: unidad.trim().toUpperCase() || 'UND',
      categoria,
      proyecto_id: proyElegido ? proyElegido.id : null,
      proyecto_nombre: proyElegido ? proyElegido.nombre : null,
      equipos: [],
      materiales: [],
      transportes: [],
      mano_obra: [],
      aiu: {
        porcentaje_admin: 10,
        porcentaje_imprevistos: 0,
        porcentaje_utilidad: 3,
        porcentaje_iva_utilidad: 19,
      },
    })

    setCodigo('')
    setNombre('')
    setDescripcion('')
    setUnidad('UND')
    setCategoria('General')
    onCerrar()
  }

  return (
    <div className={estilos.modalVelo} onClick={onCerrar}>
      <div className={estilos.modalCajaAiu} onClick={(e) => e.stopPropagation()} style={{ maxWidth: '520px' }}>
        <header className={estilos.modalHeader}>
          <h3>Crear Nueva Actividad APU</h3>
          <button type="button" className={estilos.btnCerrarModal} onClick={onCerrar} title="Cerrar">
            <IconoCerrar />
          </button>
        </header>

        <form onSubmit={handleSubmit}>
          <div className={estilos.modalCuerpoAiu}>
            <div style={{ display: 'grid', gridTemplateColumns: '120px 1fr', gap: '12px' }}>
              <div>
                <label style={{ fontSize: '0.78rem', fontWeight: 800, color: '#334155' }}>Código</label>
                <input
                  type="text"
                  placeholder="Ej: APU-01"
                  value={codigo}
                  onChange={(e) => setCodigo(e.target.value.toUpperCase())}
                  style={{ width: '100%', boxSizing: 'border-box', padding: '8px 10px', borderRadius: '6px', border: '1px solid #cbd5e1', fontWeight: 700 }}
                />
              </div>
              <div>
                <label style={{ fontSize: '0.78rem', fontWeight: 800, color: '#334155' }}>Categoría</label>
                <select
                  value={categoria}
                  onChange={(e) => setCategoria(e.target.value)}
                  style={{ width: '100%', boxSizing: 'border-box', padding: '8px 10px', borderRadius: '6px', border: '1px solid #cbd5e1', fontWeight: 600, background: '#ffffff' }}
                >
                  {CATEGORIAS_APU.map((cat) => (
                    <option key={cat} value={cat}>
                      {cat}
                    </option>
                  ))}
                </select>
              </div>
            </div>

            <div>
              <label style={{ fontSize: '0.78rem', fontWeight: 800, color: '#334155' }}>Ámbito / Proyecto Asociado</label>
              <select
                value={proyectoId}
                onChange={(e) => setProyectoId(e.target.value)}
                style={{ width: '100%', boxSizing: 'border-box', padding: '8px 10px', borderRadius: '6px', border: '1px solid #cbd5e1', fontWeight: 600, background: '#ffffff' }}
              >
                <option value="">Catálogo Maestro (Global para todos los proyectos)</option>
                {proyectosDisponibles.map((p) => (
                  <option key={p.id} value={p.id}>
                    Proyecto: {p.nombre}
                  </option>
                ))}
              </select>
            </div>

            <div>
              <label style={{ fontSize: '0.78rem', fontWeight: 800, color: '#334155' }}>Nombre de la Actividad *</label>
              <input
                type="text"
                required
                placeholder="Ej: Suministro e instalación de tubería PVC 1 pulgada..."
                value={nombre}
                onChange={(e) => setNombre(e.target.value)}
                style={{ width: '100%', boxSizing: 'border-box', padding: '8px 10px', borderRadius: '6px', border: '1px solid #cbd5e1', fontWeight: 700 }}
              />
            </div>

            <div style={{ display: 'grid', gridTemplateColumns: '120px 1fr', gap: '12px' }}>
              <div>
                <label style={{ fontSize: '0.78rem', fontWeight: 800, color: '#334155' }}>Unidad de Medida</label>
                <input
                  type="text"
                  value={unidad}
                  placeholder="UND, ML, M2..."
                  onChange={(e) => setUnidad(e.target.value.toUpperCase())}
                  style={{ width: '100%', boxSizing: 'border-box', padding: '8px 10px', borderRadius: '6px', border: '1px solid #cbd5e1', fontWeight: 800, textAlign: 'center' }}
                />
              </div>
              <div>
                <label style={{ fontSize: '0.78rem', fontWeight: 800, color: '#334155' }}>Descripción o Especificación Técnica</label>
                <input
                  type="text"
                  placeholder="Detalles constructivos y alcance..."
                  value={descripcion}
                  onChange={(e) => setDescripcion(e.target.value)}
                  style={{ width: '100%', boxSizing: 'border-box', padding: '8px 10px', borderRadius: '6px', border: '1px solid #cbd5e1' }}
                />
              </div>
            </div>
          </div>

          <footer className={estilos.modalFooter}>
            <button type="button" className={estilos.btnCancelar} onClick={onCerrar}>
              Cancelar
            </button>
            <button type="submit" className={estilos.btnGuardar}>
              Crear Actividad en el Banco
            </button>
          </footer>
        </form>
      </div>
    </div>
  )
}

